import {NgModule} from '@angular/core';
import {NotificationRoutingModule} from './notification-routing.module';
import {NotificationItemComponent} from './notification-item/notification-item.component';
import {NotificationDetailComponent} from './notification-detail/notification-detail.component';
import {NotificationDialogComponent} from './notification-dialog/notification-dialog.component';
import {SharedModule} from '../../shared/shared.module';

const COMPONENTS = [
    NotificationItemComponent,
    NotificationDetailComponent,
];

const COMPONENTS_DYNAMIC = [
    NotificationDialogComponent
];

@NgModule({
    imports: [NotificationRoutingModule, SharedModule],
    declarations: [...COMPONENTS, ...COMPONENTS_DYNAMIC],
    exports: [...COMPONENTS],
    entryComponents: [...COMPONENTS_DYNAMIC]
})
export class NotificationModule {
}
